<template lang="pug">
  #app(:class="{ 'dark' : $route.meta.pageColor }")
    Loader(v-show="loading")
    BookNow(@closeMenu="closeMenu")
    MyMenu(
      :site="this.site"
      :color="black"
      :close="close"
    )
    ExtraButton(v-if="menuItems.extraButton" :extraButton="menuItems.extraButton")
    router-view(:class="booking ? 'hide' : 'show'" @loaded="loaded")
</template>

<script>
import debug from 'debug'
import { mapActions, mapState } from 'vuex'

import MyMenu from '@/components/Menu'
import BookNow from '@/components/BookNow'
import Loader from '@/components/Loader'
import ExtraButton from '@/components/ExtraButton'

import { TweenMax } from 'gsap'

const log = debug('app')

export default {
  name: 'app',
  data () {
    return {
      cream: 'cream',
      black: 'dark',
      transitionName: '',
      close: null,
    }
  },
  beforeCreate () {
  },
  created () {
    this.init(this.$parent.site)
  },
  watch: {
    $route (to, from) {
      if (to.meta.pageColor === 'dark') {
        document.body.style.background = '#2a2423'
      } else {
        document.body.style.background = '#f6eeeb'
      }
    },
  },
  mounted () {
    log('App Mounted', this.$parent.site)
    window.addEventListener('scroll', (e) => {
      // If booking is true - desktop?
      e.preventDefault()
    })
  },
  computed: {
    ...mapState(['site', 'loading']),
    ...mapState('menu', ['booking', 'menuItems']),
  },
  methods: {
    ...mapActions(['init', 'setLoading']),
    loaded () {
      this.setLoading(false)
    },
    closeMenu () {
      this.close = true
    },

  },
  components: {
    MyMenu,
    BookNow,
    Loader,
    ExtraButton,
  },
}
</script>

<style lang="scss">
@import './styles/main';

#app {
  overflow-x: hidden;
  min-height: 100%;
  position: relative;
  background: $cream;

  &.dark {
    background: $black;
  }
}

.hide {
  overflow: hidden;
  animation: height 0.5s linear 2s forwards;

  .modules {
    transition: all 0.5s ease 1.5s;
    max-height: 100vh;
    opacity: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
  }
}

.mobile {
  height: 100vh;
  overflow: hidden;
}

@keyframes height {
  0% {
    height: 100%;
  }

  100% {
    height: 0;
  }
}
</style>
